import React, { useEffect, useState } from 'react';
import api from '../../api/api';
import ShopProducts from '../products/ShopProducts';

const FeaturedCollection = ({ settings, sellerId }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            if (!sellerId) return;
            try {
                const { data } = await api.get('/home/get-products-by-seller', {
                    params: {
                        sellerId,
                        category: settings.category,
                        limit: settings.productCount || 4
                    }
                });
                setProducts(data.products);
            } catch (error) {
                console.error("Error fetching featured products", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [sellerId, settings.category, settings.productCount]);

    if (loading) return <div className="w-full h-64 flex items-center justify-center">Loading...</div>;
    if (products.length === 0) return null;

    return (
        <div className="py-12 w-[80%] md:w-[90%] sm:w-[90%] lg:w-[90%] mx-auto">
            {settings.title && <h2 className="text-3xl font-bold text-center mb-8">{settings.title}</h2>}
            <div className="w-full">
                <div className="pl-8 md:pl-0">
                    <ShopProducts products={products} styles="grid" storeMode={true} customSettings={settings} />
                </div>
            </div>
        </div>
    );
};

export default FeaturedCollection;